import { BlockedNumberModalStyles } from './BlockedNumberModal.styles'
import { BlockedNumberStyles } from './BlockedNumbers.styles'
import { CallCenterSettingsStyle } from './CallCenterSettings.style'
import { PhoneSettingsStyles } from './PhoneSettings.styles'
import { ProfileSettingsStyle } from './ProfileSettings.style'
import { SharedSettingsStyle } from './SharedSettings.style'

// This is referenced in src/themes/defaultTheme.ts
export const settingsComponentStyles = {
  components: {
    ProfileSettingsStyle,
    SharedSettingsStyle,
    BlockedNumberStyles,
    BlockedNumberModalStyles,
    PhoneSettingsStyles,
    CallCenterSettingsStyle,
  },
}
